import _ from 'lodash';
import moment from 'moment';
import PolicySearchUtil from 'gw-portals-util-angular/PolicySearchUtil';
import templateStr from 'text!./activity-summary.html';

export default [() => {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            tableConfig: '=',
            accountNumber: '@',
            policyNumber: '@',
            jobNumber: '@',
            getActivitiesFunction: '&' // Function returning a promise that returns Activities
        },
        controller: ['$scope', '$q', '$modal', '$location', 'ActivityService', 'UserService', 'ModalService', 'AccountService', 'PolicyService', '$filter', ($scope, $q, $modal, $location, ActivityService, UserService, ModalService, AccountService, PolicyService, $filter) => {
            $scope.activities = [];
            $scope.failToGetActivities = false;
            $scope.loading = true;

            init();

            function init() {
                if (!$scope.tableConfig) {
                    $scope.tableConfig = {
                        actStatus: 'Open, Assigned to me',
                        defaultActStatus: 'Open, Assigned to me',
                        actStatusOptions: {
                            'allOpen': $filter('translate')('gateway.directives.ActivitySummary.All Open'),
                            'allClosed': $filter('translate')('gateway.directives.ActivitySummary.All Closed'),
                            'overdue': $filter('translate')('gateway.directives.ActivitySummary.Overdue'),
                            'openAssignedToMe': $filter('translate')('gateway.directives.ActivitySummary.Open, Assigned to me')
                        },
                        showAddActivity: false
                    };
                }

                const getActivitiesPromise = $scope.getActivitiesFunction();
                getActivitiesPromise.then(assignActivities, () => {
                    $scope.failToGetActivities = true;
                    $scope.loading = false;
                });
            }

            function assignActivities(promiseActivities) {
                $scope.activities = promiseActivities;
                $scope.loading = false;

                $scope.$emit('activitiesUpdated', _.filter($scope.activities, {
                    status: 'open'
                }));
            }

            $scope.getFilteredActivities = () => {
                let filteredActivities = $scope.activities;

                if ($scope.tableConfig.actStatus) {
                    filteredActivities = $filter('filter')(filteredActivities, filterByActivityStatus);
                }
                if ($scope.tableConfig.search) {
                    filteredActivities = $filter('filter')(filteredActivities, activitySearchFilter);
                }

                return filteredActivities;
            };

            /**
             * Custom search filter for Activity Summaries
             *
             * @param {Object} activity
             * @returns {Boolean} - true if the filter string matches the activity due date, subject, or accountholder name, otherwise false
             */
            const activitySearchFilter = (activity) => {
                const lowerCaseSearch = _.lowercase($scope.tableConfig.search);

                return activityDateFilter(lowerCaseSearch, activity.dueDate) ||
                    activitySubjectFilter(lowerCaseSearch, activity.subject) ||
                    activityAssigneeFilter(lowerCaseSearch, activity.assignedTo.displayName) ||
                    activityAccountHolderFilter(lowerCaseSearch, activity.accountHolderName);
            };

            function activityDateFilter(search, dueDate) {
                return (angular.isDefined(dueDate) && _.lowercase($filter('date')(dueDate, 'shortDate')).indexOf(search || '') !== -1);
            }

            function activitySubjectFilter(search, subject) {
                return _.lowercase(subject).indexOf(search || '') !== -1;
            }

            function activityAccountHolderFilter(search, accountHolder) {
                return _.lowercase(accountHolder).indexOf(search || '') !== -1;
            }

            function activityAssigneeFilter(search, assignee) {
                return _.lowercase(assignee).indexOf(search || '') !== -1;
            }

            function filterByActivityStatus(activity) {
                if ($scope.tableConfig.actStatus === 'allOpen') {
                    return activity.status === 'open';
                } else if ($scope.tableConfig.actStatus === 'overdue') {
                    return activity.status === 'open' && moment(activity.dueDate).isBefore(moment(), 'day');
                } else if ($scope.tableConfig.actStatus === 'allClosed') {
                    return activity.status === 'complete';
                } else if ($scope.tableConfig.actStatus === 'openAssignedToMe') {
                    return activity.isAssignedToCurrentUser === true && activity.status === 'open';
                }
                return false;
            }


            $scope.getPolicyTypeIcon = PolicySearchUtil.getPolicyTypeIconPath;

            $scope.showPolicy = () => {
                return !($scope.policyNumber || $scope.jobNumber || $scope.accountNumber);
            };

            $scope.showAccount = () => {
                return !($scope.accountNumber || $scope.jobNumber || $scope.policyNumber);
            };

            $scope.showLine = () => {
                return !($scope.jobNumber || $scope.policyNumber);
            };

            $scope.showAssignedBy = () => {
                return !!($scope.jobNumber);
            };

            $scope.showAssignedTo = () => {
                return !!($scope.policyNumber || $scope.jobNumber || $scope.policyNumber);
            };

            /**
             * Get a policy icon or a policy type.
             * @param {String} priority
             * @returns {String}
             */
            $scope.getPriorityIcon = (priority) => {
                return `../styles/images/icons/priorities/${priority}_16px.png`;
            };
        }]
    };
}];
